import { Edit } from "@/components/admin/edit";
import { SimpleForm } from "@/components/admin/simple-form";
import { CategoryInputs } from "./CategoryInputs";

export const CategoryEdit = () => (
  <Edit mutationMode="pessimistic" redirect="list">
    <SimpleForm className="max-w-2xl">
      <CategoryInputs />
    </SimpleForm>
  </Edit>
);
